module.exports = __webpack_public_path__ + "img/banner.2c9de711.png";